
interface ColumnItem {
    id: number;
    name: string;
    checked: boolean;
  }

  export const initialColumnUsers = [
    { id: 1, name: 'UserID', checked: true, key:'userID' }, 
    { id: 2, name: 'NAME', checked: true, key:'firstName' }, 
    { id: 3, name: 'EMAIL', checked: true, key:'email' }, 
    { id: 4, name: 'PHONE', checked: true, key:'cellPhone' }, 
    { id: 5, name: 'TEAM', checked: true, key:'team' }, 
    { id: 6, name: 'STATUS', checked: true, key:'active' }, 

  ];
  
